import React, { type FC } from 'react'
import { Box, type SxProps, type Theme } from '@mui/material'

const wrapperStyle: SxProps<Theme> = { textAlign: 'center' }

const smallStyle: SxProps<Theme> = { my: 1 }
const regularStyle: SxProps<Theme> = { my: 1 }
const marginStyles = { small: smallStyle, regular: regularStyle } as const

export type BaseLoaderProps = Readonly<{ margin?: keyof typeof marginStyles }>

export const BaseLoader: FC<BaseLoaderProps> = ({ margin = 'regular', ...props }) => <Box {...props} sx={[wrapperStyle, marginStyles[margin]]} />
